import { render } from "./why-edim.vue?vue&type=template&id=6ca41c9a"
import script from "./why-edim.vue?vue&type=script&lang=js"
export * from "./why-edim.vue?vue&type=script&lang=js"
script.render = render

export default script